module.exports = __webpack_public_path__ + "static/media/tyre-middle.63b21767.png";